import { errorPage } from 'app/scripts/controller/errorPage';
import { unlessRouteChanged } from 'app/scripts/controller/unlessRouteChanged';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { isMemberOfOrg, redirectHomeToDefaultTab } from './memberPageHelpers';

export const memberHomeBoardsPage = function (orgname: string) {
  // Error early for not-logged-in users
  if (!Auth.isLoggedIn()) {
    // a not-logged-in user cannot be a member of any board
    return errorPage({});
  }

  // Redirect early for non-existent orgs, before trying to load models
  return ModelCache.waitFor('Member', Auth.myId(), () => {
    if (!isMemberOfOrg(orgname)) {
      // @ts-expect-error
      return redirectHomeToDefaultTab.call(this);
    }

    // this is will show the org boards
    // adding these model loaders so we can show org boards that the user isn't a member of
    return unlessRouteChanged(
      ModelLoader.loadOrganizationBoardsDataMinimal(orgname),
    )
      .then((org) => {
        const opts = {
          orgname,
          showHomeBoardsTab: true,
          showGettingStarted: false,
        };
        // @ts-expect-error
        return this.memberHomePage(opts);
      })
      .catch(() => null);
  });
};
